import { View } from 'react-native'

import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorBorderNeutralDefault,
      borderRadius: theme.borderRadiusForm,
      backgroundColor: theme.colorFillNeutralDefault,
      minWidth: 256,
      maxWidth: theme.sizingMedium * theme.sizingSmall,
      overflow: 'hidden',
    },
    variants: {
      full: {
        true: {
          width: '100%',
        },
      },
      type: {
        'brand-accent': {
          backgroundColor: theme.colorFillNeutralDefault,
        },
        info: {
          backgroundColor: theme.colorFillInformativeAlternative,
        },
        success: {
          backgroundColor: theme.colorFillSuccessAlternative,
        },
        warning: {
          backgroundColor: theme.colorFillWarningAlternative,
        },
        danger: {
          backgroundColor: theme.colorFillDangerAlternative,
        },
      },
    },
  }
})
